/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignsSavedPayload
 */
export interface SignsSavedPayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: SignsSavedPayloadTypeEnum;
    /**
     * 
     */
    signs: { [key: string]: any; };
}


/**
 * @export
 */
export const SignsSavedPayloadTypeEnum = {
    SignsSaved: 'signs_saved',
} as const;
export type SignsSavedPayloadTypeEnum = typeof SignsSavedPayloadTypeEnum[keyof typeof SignsSavedPayloadTypeEnum];


/**
 * Check if a given object implements the SignsSavedPayload interface.
 */
export function instanceOfSignsSavedPayload(value: object): value is SignsSavedPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'signs_saved') return false;
    
    if (!('signs' in value) || value['signs'] === undefined) return false;
    return true;
}

export function SignsSavedPayloadFromJSON(json: any): SignsSavedPayload {
    return SignsSavedPayloadFromJSONTyped(json, false);
}

export function SignsSavedPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignsSavedPayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'signs': json['signs'],
    };
}

export function SignsSavedPayloadToJSON(json: any): SignsSavedPayload {
    return SignsSavedPayloadToJSONTyped(json, false);
}

export function SignsSavedPayloadToJSONTyped(value?: SignsSavedPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'signs': value['signs'],
    };
}

